var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useAppSelector } from "@/hooks/store";
import { Chip } from "@mui/joy";
import moment from "moment";
import { useEffect, useState } from "react";
import "moment/locale/fr";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/pro-solid-svg-icons";
import { useGetSearchHistoryQuery } from "@/store/api";
import { useColorIcons } from "@/utils/themes/hooks";
import { useTranslation } from "react-i18next";
moment.locale("fr");
function History(_a) {
    var setInputValue = _a.setInputValue, setChips = _a.setChips, dataRecentSearch = _a.dataRecentSearch;
    var t = useTranslation(["common"]).t;
    var _b = useState(0), startIndex = _b[0], setStartIndex = _b[1];
    var _c = useState([]), recentSearch = _c[0], setRecentSearch = _c[1];
    var colors = useAppSelector(function (state) { return state.colorsIcon.colors_state_list; });
    var _d = useState(false), isNextClicked = _d[0], setIsNextClicked = _d[1];
    var _e = useGetSearchHistoryQuery({}), dataSearchHistory = _e.data, refetch = _e.refetch;
    useEffect(function () {
        var _a, _b;
        if (dataRecentSearch === undefined || (dataRecentSearch === null || dataRecentSearch === void 0 ? void 0 : dataRecentSearch.length) <= 0) {
            refetch();
            if ((_a = dataSearchHistory === null || dataSearchHistory === void 0 ? void 0 : dataSearchHistory.data) === null || _a === void 0 ? void 0 : _a.recent_searches) {
                setRecentSearch((_b = dataSearchHistory === null || dataSearchHistory === void 0 ? void 0 : dataSearchHistory.data) === null || _b === void 0 ? void 0 : _b.recent_searches);
            }
        }
        else {
            dataRecentSearch && setRecentSearch(dataRecentSearch);
        }
    }, [dataSearchHistory, dataRecentSearch]);
    var handleNextClick = function () {
        if (startIndex + 5 < recentSearch.length) {
            setStartIndex(startIndex + 5);
        }
    };
    var handlePrevClick = function () {
        if (startIndex - 5 >= 0) {
            setStartIndex(startIndex - 5);
        }
    };
    var colorIcons = useColorIcons();
    return (_jsx(_Fragment, { children: recentSearch && (_jsxs("ul", __assign({ className: "text-sm text-[var(--colors-label)] border-t px-4 py-2 mt-4" }, { children: [_jsx("li", __assign({ className: "py-2" }, { children: _jsx("span", __assign({ className: "font-medium" }, { children: t("app.LBL_RECENT_RESEARCH") })) })), recentSearch
                    .slice(startIndex, startIndex + 5)
                    .map(function (item, index) { return (_jsxs("li", __assign({ className: "flex mb-3 justify-between cursor-pointer hover:rounded-sm hover:bg-[var(--colors-body-bg-sec)] text-xs", onClick: function () {
                        setInputValue(item.term);
                        setChips(item.modules);
                    } }, { children: [_jsxs("div", __assign({ className: "flex gap-1  flex-wrap" }, { children: [_jsxs(Chip, __assign({ size: "sm", color: "neutral", variant: "outlined", sx: {
                                        backgroundColor: "#D3D3D340",
                                    } }, { children: ["\"", item.term, "\""] })), item.modules.map(function (module, i) { return (_jsx(Chip, __assign({ sx: {
                                        border: "1px solid ".concat(colorIcons && colorIcons[module]),
                                        color: "".concat(colorIcons && colorIcons[module]),
                                        backgroundColor: "".concat(colorIcons && colorIcons[module], "10"),
                                    }, size: "sm", variant: "outlined" }, { children: module }), i)); })] })), _jsx("span", __assign({ className: "text-[var(--colors-label)] text-xs" }, { children: moment(item.dateCreated)
                                .fromNow()
                                .replace("il y a", "")
                                .replace("ago", "") }))] }), index)); }), _jsx("li", __assign({ className: "py-2 cursor-pointer", onClick: function () {
                        setIsNextClicked(!isNextClicked);
                        if (isNextClicked) {
                            handlePrevClick();
                        }
                        else {
                            handleNextClick();
                        }
                    } }, { children: _jsxs("div", __assign({ className: "flex items-center justify-center w-full" }, { children: [_jsx("div", { className: "flex-1 border-t border-gray-300" }), _jsxs("div", __assign({ className: "mx-2 flex flex-col text-gray-400 leading-none" }, { children: [_jsx(FontAwesomeIcon, { icon: isNextClicked ? faChevronUp : faChevronDown, className: "text-md", onClick: handlePrevClick }), _jsx(FontAwesomeIcon, { icon: isNextClicked ? faChevronUp : faChevronDown, className: "text-md mt-[-8px]", onClick: handleNextClick })] })), _jsx("div", { className: "flex-1 border-t border-gray-300" })] })) }))] }))) }));
}
export default History;
